import { defineRoute } from '../defineRoute';

export const DEFAULT_PAYMENT_INTENT_ID = '';

export type PaymentReminderRouteParams = {
  paymentIntentId?: string | null;
};

export type PaymentReminderRouteParamsString = {
  paymentIntentId?: string;
};

export const PaymentReminder = defineRoute<
  PaymentReminderRouteParams,
  PaymentReminderRouteParamsString
>({
  pathname: '/payment-reminder',
  nlPathname: '/betalingsherinnering',
  options: { isLandlordRoute: false, isPublic: true },
  routeParamsStringifier: routeParams => {
    return {
      paymentIntentId: routeParams.paymentIntentId ?? undefined,
    };
  },
  routeParamsParser: routeParamsString => {
    return {
      paymentIntentId:
        routeParamsString.paymentIntentId || DEFAULT_PAYMENT_INTENT_ID,
    };
  },
});
